//
// DragMode.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var DragMode = {
    INVALID:0,
    PAN:1,
    RECTANGLE_SELECT:2,
    RADIAL_SELECT:3,
    FREEFORM_SELECT:4,
    POLYGON_SELECT:5,
    ZOOM:6,
    NONE:7
};
export default DragMode;
